import Dashboard from "layouts/dashboard";

// @mui icons
import Icon from "@mui/material/Icon";
import Subjects from "Main/Views/Subjects";
import Exams from "Main/Views/Exams";
import ExamLists from "Main/Views/ExamLists";
import ExamListSets from "Main/Views/ExamListSets";
import AutoCreateExamListSets from "AddViews/AutoCreateExamListSets";
import Years from "Main/Views/Years";
import Topics from "Main/Views/Topics";
import Levels from "Main/Views/Levels";
import ArLevels from "Main/Views/ArLevels";
import Questions from "Main/Views/Questions";
import ArQuestions from "Main/Views/ArQuestions";
import AgriBoost from "Main/Views/AgriBoost";
import PreviousYearQuestions from "Main/Views/PreviousYearQuestions";
import PreviousYearDocuments from "Main/Views/PreviousYearDocuments";
import Users from "Main/Views/Users";
import ActiveUsers from "Main/Views/ActiveUsers";
import Employees from "Main/Views/Employees";
import Universities from "Main/Views/Universities";
import TestSeries from "Main/Views/TestSeries";
import LiveTests from "Main/Views/LiveTests";
import Blogs from "Main/Views/Blogs";
import Gallery from "Main/Views/Gallery";
import News from "Main/Views/News";
import WebContacts from "Main/Views/WebContacts";
import Notifications from "Main/Views/Notifications";
import SupportIssues from "Main/Views/SupportIssues";
import UserAttemptReports from "Main/Views/UserAttemptReports";
import AdminAnalytics from "Main/Views/AdminAnalytics";
import FeatureAnalytics from "Main/Views/FeatureAnalytics";
import FriendsTestReports from "Main/Views/FriendsTestReports";
import LearningAttemptReports from "Main/Views/LearningAttemptReports";
import EventRegistrations from "Main/Views/EventRegistrations";
import AppRuntimeSettings from "Main/Views/AppRuntimeSettings";
import WalletWithdrawals from "Main/Views/WalletWithdrawals";
import SubscriptionManagement from "Main/Views/SubscriptionManagement";
import Transactions from "Main/Views/Transactions";

let users = localStorage.getItem("admin_details");
let user;

if (users) {
  user = JSON.parse(users);
}

const normalizedAdminRole = String(user?.role || "").toLowerCase();
const hasFullAdminAccess = normalizedAdminRole === "superadmin" || normalizedAdminRole === "admin";

let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },

  {
    type: "collapse",
    name: "Subjects",
    key: "career",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/subjects",
    component: <Subjects />,
  },
  {
    type: "collapse",
    name: "Topics",
    key: "topics",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/topics",
    component: <Topics />,
  },
  {
    type: "collapse",
    name: "Levels",
    key: "levels",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/levels",
    component: <Levels />,
  },
  {
    type: "collapse",
    name: "AR Levels",
    key: "ar-levels",
    icon: <Icon fontSize="small">stairs</Icon>,
    route: "/ar-levels",
    component: <ArLevels />,
  },
  {
    type: "collapse",
    name: "Questions",
    key: "questions",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/questions",
    component: <Questions />,
  },
  {
    type: "collapse",
    name: "AR Questions",
    key: "ar-questions",
    icon: <Icon fontSize="small">rule</Icon>,
    route: "/ar-questions",
    component: <ArQuestions />,
  },
  {
    type: "collapse",
    name: "AgriBoost",
    key: "agriboost",
    icon: <Icon fontSize="small">bolt</Icon>,
    route: "/agriboost",
    component: <AgriBoost />,
  },
  {
    type: "collapse",
    name: "Test Series",
    key: "testseries",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/testseries",
    component: <TestSeries />,
  },
  {
    type: "collapse",
    name: "Live Tests",
    key: "live-tests",
    icon: <Icon fontSize="small">bolt</Icon>,
    route: "/live-tests",
    component: <LiveTests />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "Active Users",
    key: "active-users",
    icon: <Icon fontSize="small">leaderboard</Icon>,
    route: "/active-users",
    component: <ActiveUsers />,
  },
  {
    type: "collapse",
    name: "User Reports",
    key: "user-attempt-reports",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/user-attempt-reports",
    component: <UserAttemptReports />,
  },
  {
    type: "collapse",
    name: "Monthly Analytics",
    key: "monthly-analytics",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/monthly-analytics",
    component: <AdminAnalytics />,
  },
  {
    type: "collapse",
    name: "Feature Analytics",
    key: "feature-analytics",
    icon: <Icon fontSize="small">insights</Icon>,
    route: "/feature-analytics",
    component: <FeatureAnalytics />,
  },
  {
    type: "collapse",
    name: "Friends Test Reports",
    key: "friends-test-reports",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/friends-test-reports",
    component: <FriendsTestReports />,
  },
  {
    type: "collapse",
    name: "PYQ & AR Attempts",
    key: "learning-attempt-reports",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/learning-attempt-reports",
    component: <LearningAttemptReports />,
  },
  {
    type: "collapse",
    name: "App Settings",
    key: "app-runtime-settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/app-settings",
    component: <AppRuntimeSettings />,
  },
  {
    type: "collapse",
    name: "Subscriptions",
    key: "subscription-management",
    icon: <Icon fontSize="small">workspace_premium</Icon>,
    route: "/subscriptions",
    component: <SubscriptionManagement />,
  },
  {
    type: "collapse",
    name: "Wallet Withdrawals",
    key: "wallet-withdrawals",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet-withdrawals",
    component: <WalletWithdrawals />,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/transactions",
    component: <Transactions />,
  },
  {
    type: "collapse",
    name: "Event Registrations",
    key: "event-registrations",
    icon: <Icon fontSize="small">event_note</Icon>,
    route: "/event-registrations",
    component: <EventRegistrations />,
  },
  {
    type: "collapse",
    name: "Colleges",
    key: "colleges",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/colleges",
    component: <Universities />,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "blogs",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogs",
    component: <Blogs />,
  },
  {
    type: "collapse",
    name: "Gallery",
    key: "gallery",
    icon: <Icon fontSize="small">photo_library</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },
  {
    type: "collapse",
    name: "News",
    key: "news",
    icon: <Icon fontSize="small">newspaper</Icon>,
    route: "/news",
    component: <News />,
  },
  {
    type: "collapse",
    name: "Exams",
    key: "exams",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/exams",
    component: <Exams />,
  },
  {
    type: "collapse",
    name: "Years",
    key: "years",
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: "/years",
    component: <Years />,
  },
  {
    type: "collapse",
    name: "Exam Lists",
    key: "exam-lists",
    icon: <Icon fontSize="small">view_list</Icon>,
    route: "/exam-lists",
    component: <ExamLists />,
  },
  {
    type: "collapse",
    name: "Exam List Sets",
    key: "exam-list-sets",
    icon: <Icon fontSize="small">dataset</Icon>,
    route: "/exam-list-sets",
    component: <ExamListSets />,
  },
  {
    type: "collapse",
    name: "Auto Create Sets",
    key: "auto-create-exam-list-sets",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/auto-create-exam-list-sets",
    component: <AutoCreateExamListSets />,
  },
  {
    type: "collapse",
    name: "Previous Year Questions",
    key: "previous-year-questions",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/previous-year-questions",
    component: <PreviousYearQuestions />,
  },
  {
    type: "collapse",
    name: "PDF Resources",
    key: "previous-year-documents",
    icon: <Icon fontSize="small">picture_as_pdf</Icon>,
    route: "/previous-year-documents",
    component: <PreviousYearDocuments />,
  },
  {
    type: "collapse",
    name: "Employees",
    key: "employees",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/employees",
    component: <Employees />,
  },
  {
    type: "collapse",
    name: "Web Contacts",
    key: "webcontacts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/webcontacts",
    component: <WebContacts />,
  },
  {
    type: "collapse",
    name: "Support Issues",
    key: "supportissues",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support-issues",
    component: <SupportIssues />,
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  // {
  //   type: "collapse",
  //   name: "Applicants",
  //   key: "applicants",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/applicants",
  //   component: <AllApplications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Contacts",
  //   key: "contacts",
  //   icon: <Icon fontSize="small">list_view</Icon>,
  //   route: "/contacts",
  //   component: <AllContacts />,
  // },
  // {
  //   type: "collapse",
  //   name: "Pop-Up",
  //   key: "popup",
  //   icon: <Icon fontSize="small">list_view</Icon>,
  //   route: "/popup",
  //   component: <Popup />,
  // },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/sign-in",
  //   component: <SignIn />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

let newRoutes = [];

if (user?.employee_type === "question_creater") {
  // console.log(user);
  routes.filter((item) => {
    if (
      item.route === "/questions" ||
      item.route === "/ar-levels" ||
      item.route === "/ar-questions" ||
      item.route === "/agriboost" ||
      item.route === "/subjects" ||
      item.route === "/levels" ||
      item.route === "/topics" ||
      item.route === "/dashboard"
    ) {
      newRoutes.push(item);
    }
  });
}

if (user?.employee_type == "question_approver") {
  routes.filter((item) => {
    if (
      item.route === "/questions" ||
      item.route === "/agriboost" ||
      item.route === "/dashboard" ||
      item.route === "/testseries" ||
      item.route === "/live-tests"
    ) {
      newRoutes.push(item);
    }
  });
}
if (user?.employee_type === "test_series_manager") {
  routes.filter((item) => {
    if (
      item.route === "/dashboard" ||
      item.route === "/monthly-analytics" ||
      item.route === "/learning-attempt-reports" ||
      item.route === "/testseries" ||
      item.route === "/live-tests"
    ) {
      newRoutes.push(item);
    }
  });
}
if (hasFullAdminAccess) {
  newRoutes = routes;
}
routes = newRoutes;
export default routes;
